import GravityFormsContextProvider from './state/GravityFormsProvider';
import GravityFormsForm from './GravityFormsForm';
import { GravityFormFragmentAttributes } from './types';

interface Props {
  disclaimer?: null | string;
  form: GravityFormFragmentAttributes['form'];
  onSuccess?: () => void;
}

const GravityForm = ({
  disclaimer,
  form,
  onSuccess,
}: Props) => {
  if (!form) {
    return null;
  }

  return (
    <GravityFormsContextProvider>
      <GravityFormsForm
        disclaimer={disclaimer}
        form={form}
        onSuccess={onSuccess}
      />
    </GravityFormsContextProvider>
  );
};

export default GravityForm;
